import { Typography } from '@mui/material';
import React from 'react';
import OrderWorkunit from 'types/entities/OrderWorkunit';

const NameCell = React.memo((row: OrderWorkunit) => (
  <Typography noWrap variant="body2">
    {row.workunit_name ?? ''}
  </Typography>
));

export default NameCell;
